import { apiFetch } from "./services/api";
export type User = {
  id: number;
  email: string;
  role: "user" | "admin";
  plan: string;
  credits: number;
  subscription_status: string;
};
export type Lead = {
  id: number;
  first_name: string;
  last_name: string;
  job_title: string;
  company: string;
  industry: string;
  company_size: string;
  city: string;
  state: string;
  country: string;
  email_status: string;
  verification_badge: string;
  email_available: boolean;
  phone_available: boolean;
  updated_at: string;
  unlocked: boolean;
  email?: string;
  phone?: string;
  website?: string;
  linkedin_url?: string;
  details?: Record<string,string>;
};
export type LeadList = { id: number; name: string; count: number };
export function refreshAccount() {
  window.dispatchEvent(new Event("reachatlas:account"));
}
export async function downloadContacts(body: {
  lead_ids?: number[];
  all?: boolean;
  list_id?: number;
}) {
  const response = await apiFetch("/api/export", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok)
    throw new Error((await response.json()).error || "Download failed");
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "reachatlas-contacts.csv";
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
